import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateResult } from "../../models/create-result";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { TerminalConfigService } from "../../services/terminal-config.service";
import { ChangeDetectorRef } from '@angular/core';
import { InteractionTypeEnum } from '../../models/interaction-type-enum';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { AuthenticationService } from "../../services/authentication.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormatHelper } from "../../helpers/format-helper";
import { MerchantReportDTViewModel } from '../../models/merchant-report-dt-view-model';
import { ReportService } from '../../services/report.service';
import { Select2OptionData } from 'ng-select2';
import { ClientReportDTViewModel } from '../../models/client-report-dt-view-model';
import { TerminalReportDTViewModel } from '../../models/terminal-report-dt-view-model';
import { MerchantGroupReportDTViewModel } from '../../models/merchant-group-report-dt-view-model';


@Component({
  selector: 'app-report-merchant-view',
  templateUrl: './report-merchant-view.component.html',
  styleUrls: ['./report-merchant-view.component.scss']
})
export class ReportMerchantViewComponent implements OnInit, OnDestroy {

  public merchantForm: FormGroup;
  public submitted = false;
  public id: string;
  public createResult: CreateResult;
  private _destroyed$ = new Subject<any>();
  public error = false;
  public errorMessage = "";
  public canAdd: boolean;

  public superUser: boolean;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  private loaded = false;

  public disabled: boolean;
  public warning: string;
  public raiseWarning: boolean;
  public danger: string;
  public raiseDanger: boolean;
  public displayMPOSContent: boolean;
  public merchants: MerchantReportDTViewModel;
  public clients: Select2OptionData[];
  public allClients: ClientReportDTViewModel[];
  public terminals: TerminalReportDTViewModel[];
  public merchantNumber: string;
  public allTerminals: TerminalReportDTViewModel[];
  public allMerchantGroups: MerchantGroupReportDTViewModel[];

  public terminal: TerminalReportDTViewModel;
  public selectedTerminal: string;
  public selectedClient: string;
  public selectedMerchantGroupId: string;
  public disableTerminal: boolean;
  public newMerchant: boolean;


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private fb: FormBuilder,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _formBuilder: FormBuilder,
    private _formatHelper: FormatHelper,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService) {

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.superUser = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewGenericReport], [])
      this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups], []);
      if (!this.canAdd) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      this.allClients = await this._reportService.GetClients();
      this.clients = this.allClients.map(x => ({ id: x.id.toString(), text: x.name }));

      if (params.id == 'new' || !params.id) {
        this.merchants = {
          id: 0,
          clientId: "",
          description: "",
          merchantGroupId: "",
          merchantNumber: "",
          usnNumber: "",
          clientName: "",
          merchantID: 0,
          participantId:0
        };
        this.newMerchant = true;
        this.disabled = false;
      }
      else {
        this._ngxUiLoaderService.start();
        this.newMerchant = false;
        this.merchants = await this._reportService.GetByUSSNumber(params.id);
        this.terminals = await this._reportService.GetTerminalsByUSSNumber(params.id, this.merchants.merchantID);
        //this.allTerminals = await this._reportService.GetAllMerchantsByParticipants(this._userDataStore.selectedParticipant.id.toString());
        this.selectedClient = this.merchants.clientName + " (" + this.merchants.clientId + ")";

        this.selectedMerchantGroupId = this.merchants.merchantGroupId;
        this._ngxUiLoaderService.stop();

        this.merchantNumber = params.id;

        this.disabled = true;

      }
      if (this.selectedClient == undefined || this.selectedClient == '') {
        this.disableTerminal = true;
      }
      else {
        this.disableTerminal = false;
      }

    });
  }

  public ngOnInit() {
  }

  public async linkTerminal(): Promise<void> {
    this._ngxLoader.start();
    debugger;
    if (this.selectedTerminal == undefined || this.selectedTerminal == '') {
      this._toastService.error('Please enter a terminal', "Error");
    }
    else {
      if (!this.newMerchant) {
        this.createResult = await this._reportService.linkTerminal(this.merchants.usnNumber, this.selectedTerminal);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
          //refresh list
          this.terminals = await this._reportService.GetTerminalsByUSSNumber(this.merchants.usnNumber, this.merchants.merchantID);

        } else {
          this._toastService.error(this.createResult.message, "Error");
        }
      }
      else {
        this._toastService.warning("You need to create a merchant first before linking terminals", "Warning");
      }
    }
    this._ngxLoader.stop();
  }

  public async clientChange(): Promise<void> {
    if (this.selectedClient != undefined && this.selectedClient != '') {

      if (this.newMerchant) {
        this.allTerminals = await this._reportService.GetAllTerminalsByClient(this.selectedClient);

        this.allMerchantGroups = await this._reportService.GetAllMerchantGroups(this.selectedClient);
        if (this.allTerminals.length > 0) {
          this.disableTerminal = false;
        } else {
          this.disableTerminal = true;
        }
      }
    }
  }

  public async save(): Promise<void> {

    this._ngxUiLoaderService.start();
    if (!this.merchants.id) {
      //this.merchants.clientId = "" + this.selectedClient;
      this.merchants.merchantGroupId = "" + (this.selectedMerchantGroupId == undefined ? "" : this.selectedMerchantGroupId);
      this.createResult = await this._reportService.Create(this.merchants);
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");

        this._router.navigate(['management', 'report', this.merchants.usnNumber]);

      } else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }
    else {

      if (this.merchants.merchantGroupId.includes("(")) {
        var res = this.merchants.merchantGroupId.split("(");
        var result = res[1].replace(")", "");
        this.merchants.merchantGroupId = result;
      }
      this.createResult = await this._reportService.Update(this.merchants);
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
      } else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }

    this._ngxUiLoaderService.stop();
  }

  public async removeLink(terminal: TerminalReportDTViewModel): Promise<void> {
    this._ngxLoader.start();

    if (terminal.terminalId != '')
    {
      this.createResult = await this._reportService.removeTerminalLink(terminal.terminalId, this.merchants.usnNumber);
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
        this.terminals = await this._reportService.GetTerminalsByUSSNumber(this.merchants.usnNumber, this.merchants.merchantID);
        this.allTerminals = await this._reportService.GetAllTerminalsByClient(this.merchants.clientId);

      } else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }

    this._ngxLoader.stop();
  }


  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.dtTrigger.unsubscribe();
  }

}
